import { SearchInput } from "@/components/flexkit/SearchInput";
import type { FC, InputHTMLAttributes } from "react";

type ProjectSearchInputProps = {
    searchValue?: string;
    isLoading?: boolean;
    disabled?: boolean;
    setSearchValue: (value: string) => void;
} & InputHTMLAttributes<HTMLInputElement>;
export const ProjectSearchInput: FC<ProjectSearchInputProps> = ({
    searchValue,
    isLoading,
    disabled,
    setSearchValue,
    ...props
}) => {
    return (
        <SearchInput
            wrapperClassName="w-full"
            className="max-w-none"
            placeholder="Search projects"
            value={searchValue || ""}
            onChange={(e) => setSearchValue(e.target.value.trimStart().replace(/\s+/g, " "))}
            onClear={() => setSearchValue("")}
            isLoading={isLoading}
            disabled={disabled}
            {...props}
        />
    );
};
